<template>
  <button
    class="btn"
    type="button"
    :class="{ loading, disabled }"
    @click.stop="!loading && !disabled ? emits('click') : null"
  >
    <span v-if="label !== 'default'">{{ label }}</span>
    <span v-if="loading" class="bi bi-arrow-repeat" />
    <i v-if="icon && !loading" :class="icon" />
  </button>
</template>

<script setup>
const emits = defineEmits(["click"]);

defineProps({
  label: {
    type: String,
    default: "default",
  },
  icon: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
